import React, { useState, useEffect } from 'react';
import { useSiteData } from 'react-static';
// template components
import InPageLeadForm from '@nmx/template/dist/componentLibrary/modules/InPageLeadForm';
import InPageLeadFormLazyLoadContainer from '../../../components/inPageLeadFormLazyLoadContainer';
// other utils
import { getImmediateMatchFeatureFlag } from '../../../../utils/getFeatureFlags/getFeatureFlags';

export default () => {
  const { config } = useSiteData();
  const [immediateMatchFeatureFlag, setImmediateMatchFeatureFlag] = useState(false);

  useEffect(() => {
    getImmediateMatchFeatureFlag(setImmediateMatchFeatureFlag, config);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InPageLeadFormLazyLoadContainer>
      <InPageLeadForm
        applicationId='FAFA'
        sectionId='in-page-lead'
        config={config}
        formLocation='find-a-financial-advisor'
        immediateMatchFeatureFlagEnabled={immediateMatchFeatureFlag}
        variant='hero'
      />
    </InPageLeadFormLazyLoadContainer>
  );
};
